// extracted by mini-css-extract-plugin
export var blockedMessage = "_94-3";
export var blockedOverlay = "_94-1";
export var fadeIn = "_94-2";
export var hereLink = "_94-0";
export var slideUp = "_94-4";